/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';

import alarmClock from './images/alarm-clock.svg';
import blockPieces from './images/block-pieces.svg';
import documentPencil from './images/document-pencil.svg';
import handshake from './images/handshake.svg';
import houseChimney from './images/house-chimney.svg';
import identification from './images/identification.svg';
import padlock from './images/padlock.svg';
import peopleGroup from './images/people-group.svg';
import calendar from './images/calendar.svg';

export namespace Badge {
  export interface Props extends React.HTMLAttributes<HTMLDivElement> {
    imageName:
      | 'alarm-clock'
      | 'block-pieces'
      | 'document-pencil'
      | 'handshake'
      | 'house-chimney'
      | 'identification'
      | 'padlock'
      | 'people-group'
      | 'calendar';
    altText: string;
  }
}

const styles = StyleSheet.create({
  wrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  image: {
    width: 240,
    height: 240,
  },
});

const getImage = (imageName: string) => {
  switch (imageName) {
    case 'alarm-clock':
      return alarmClock;
    case 'block-pieces':
      return blockPieces;
    case 'document-pencil':
      return documentPencil;
    case 'handshake':
      return handshake;
    case 'house-chimney':
      return houseChimney;
    case 'identification':
      return identification;
    case 'padlock':
      return padlock;
    case 'people-group':
      return peopleGroup;
    case 'calendar':
      return calendar;
    default:
      return null;
  }
};

export const Badge: React.FC<Badge.Props> = ({ imageName, altText, ...htmlProps }) => {
  const image = getImage(imageName);
  if (!image) {
    return null;
  }

  return (
    <div className={css(styles.wrapper)} {...htmlProps}>
      <img className={css(styles.image)} src={image} alt={altText} aria-hidden="true" data-it="Badge-image" />
    </div>
  );
};
